import Vuex from "vuex"
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import app from "./modules/App";
import auth from "./modules/Auth";
import file from "@/store/modules/File";
import study from "@/store/modules/Study";
import exportStore from "@/store/modules/Export";
import notification from "@/store/modules/Notification";

Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        app,
        auth,
        file,
        study,
        exportStore,
        notification
    },
    plugins: [createPersistedState({
        reducer: persistedState => {
            const stateFilter = Object.assign({}, persistedState)
            const blackList = ["file"]

            blackList.forEach(item => {
                delete stateFilter[item]
            })

            return stateFilter
        }
    })],
})

